import { render, staticRenderFns } from "./GeoprocesoOpcionesGenerales.vue?vue&type=template&id=480bca45&scoped=true&"
import script from "./GeoprocesoOpcionesGenerales.vue?vue&type=script&lang=js&"
export * from "./GeoprocesoOpcionesGenerales.vue?vue&type=script&lang=js&"
import style0 from "./GeoprocesoOpcionesGenerales.vue?vue&type=style&index=0&id=480bca45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480bca45",
  null
  
)

export default component.exports